import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { VehicleTypeService } from '@general/proxy/general/controllers/vehicle-type.service';
import { VendorService } from '../proxy/controlling/controllers/vendor.service';
import { ShiftService } from '../proxy/controlling/controllers/shift.service';
import { VehicleCategoryService } from '@general/proxy/general/controllers/vehicle-category.service';
FieldBuilder.setNamespace('Controlling');

export const LOGISTICSTRUCKCOUNT_FIELDS: FieldDefinition[] = [
  FieldBuilder.number('quantity', 'Entity.LogisticsTruckCount.Quantity')
    .required()
    .build(),
  FieldBuilder.date('validSince', 'Entity.LogisticsTruckCount.ValidSince')
    .required()
    .build(),
  FieldBuilder.foreignKey('vehicleTypeId', 'Entity.VehicleType', VehicleTypeService)
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey('vendorId', 'Entity.Vendor', VendorService)
    .displayFromNested('vendor.fantasyName')
    .sortBy('vendor.fantasyName')
    .hideInChildForms()
    .build(),
  FieldBuilder.foreignKey('shiftId', 'Entity.Shift', ShiftService)
    .required()
    .displayFromNested('shift.name')
    .sortBy('shift.name')
    .build(),
  FieldBuilder.foreignKey('vehicleCategoryId', 'Entity.VehicleCategory', VehicleCategoryService)
    .required()
    .display('name')
    .keyField('id')
    .build(),
];

export const LOGISTICSTRUCKCOUNT_CONFIG = {
  entityName: 'LogisticsTruckCount',
  localizationKey: 'Controlling::Entity.LogisticsTruckCount',
  fields: LOGISTICSTRUCKCOUNT_FIELDS,
  permission: 'Controlling.LogisticsTruckCounts',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
